<template>
  <i
    v-if="youtubeedit.id"
    class="bi bi-arrow-left-circle back-button"
    @click="goBack"
  ></i>
  <div class="content_parent registration d-flex flex-column">
    <div v-if="id" class="title content_line">
      <div class="item_parent">
        <div class="content_title">
          <div class="texttitle">ID</div>
        </div>
        <div class="content_item">
          <p v-text="id"></p>
        </div>
      </div>
    </div>
    <div v-if="false" class="title content_line">
      <div class="item_parent">
        <div class="content_title">
          <div class="texttitle">種別</div>
        </div>
        <div class="content_item">
          <select class="form-select" v-model="youtubeedit.kind" disabled>
            <option value="1">フリー</option>
          </select>
        </div>
      </div>
    </div>
    <div class="title content_line">
      <div class="item_parent">
        <div class="content_title">
          <div class="texttitle">カテゴリ</div>
        </div>
        <div class="content_item d-flex flex-column align-items-start">
          <select
            disabled
            class="mt-2 form-select"
            v-model="youtubeedit.category"
          >
            <option
              v-for="category in categories"
              :value="category.value"
              :key="category.text"
            >
              {{ category.text }}
            </option>
          </select>
          <p v-if="isCattegoryInvalid" class="error-message">
            *カテゴリは必須項目です。
          </p>
        </div>
      </div>
    </div>
    <div class="title content_line">
      <div class="item_parent item_parent_long">
        <div class="content_title">
          <div class="texttitle">タイトル</div>
        </div>
        <div class="content_item d-flex flex-column align-items-start">
          <input
            class="form-control"
            type="text"
            maxlength="100"
            v-model="youtubeedit.title"
          />
          <div v-if="isTitleInvalid" class="err_margin error-message">
            *タイトルは必須項目です
          </div>
        </div>
      </div>
    </div>

    <div class="title content_line">
      <div class="item_parent item_parent_long">
        <div class="content_title">
          <div class="texttitle">シリーズ</div>
        </div>
        <div class="content_item">
          <input
            class="form-control"
            type="text"
            maxlength="40"
            v-model="youtubeedit.series"
          />
        </div>
      </div>
    </div>
    <div class="title content_line d-flex frex-row">
      <div class="item_parent item_parent_long">
        <div class="content_title">
          <div class="texttitle">著者</div>
        </div>
        <div class="content_item">
          <input
            class="form-control"
            type="text"
            maxlength="20"
            v-model="youtubeedit.writer"
          />
        </div>
      </div>
    </div>
    <div class="title content_line">
      <div class="item_parent item_parent_long">
        <div class="content_title">
          <div class="texttitle">タグ</div>
        </div>
        <div class="content_item">
          <input
            class="form-control"
            type="text"
            maxlength="50"
            v-model="youtubeedit.tag"
          />
        </div>
      </div>
    </div>

    <div class="title content_line body_content">
      <div class="item_parent_body d-flex flex-row">
        <div class="content-title">
          <div class="texttitle">YouTubeコード</div>
        </div>
        <div class="content_item_youtube d-flex flex-column align-items-start">
          <textarea
            class="form-control"
            v-model="youtubeedit.articleCd"
          ></textarea>
          <p v-if="isArticleCdInvalid" class="error-message">
            *YouTubeコードは必須項目です。
          </p>
        </div>
      </div>
    </div>
    <div class="title content_line body_content">
      <div class="item_parent_body d-flex flex-row">
        <div class="content-title">
          <div class="texttitle">説明文章</div>
        </div>
        <div class="content_item_youtube">
          <textarea
            class="form-control"
            v-model="youtubeedit.article"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="title content_line">
      <div class="item_parent">
        <div class="content_title">
          <div class="texttitle">サムネイル</div>
        </div>
        <div class="m-2 content_item d-flex flex-column">
          <div v-if="image" class="item_parent image">
            <img class="preview_image" :src="image" />
            <button @click="fileDelete" class="round_btn"></button>
          </div>
          <button @click="triggerFileInput" class="submit_button">
            画像を選択
          </button>
          <span v-if="image">{{ fileName }}</span>
          <input
            type="file"
            accept="image/*"
            ref="fileInput"
            style="display: none"
            @change="handleFileChange"
          />
        </div>
      </div>
    </div>

    <div class="content_line d-flex flex-row">
      <div class="content_title">
        <div class="texttitle_wrap">レース</div>
      </div>
      <div class="d-flex flex-column mt-1">
        <div class="d-flex flex-row flex-wrap">
          <div class="item_parent">
            <div class="row_texttitle">レース日</div>
            <div class="content_item">
              <VueCtkDateTimePicker
                button-now-translation="現在時刻"
                class=""
                :button-clear="false"
                v-model="youtubeedit.raceDate"
                format="YYYY-MM-DD"
                formatted="YYYY年MM月DD日"
                :no-header="true"
                label="日付を選択"
                no-label
                only-date
                auto-close
              />
            </div>
          </div>
          <div class="item_parent">
            <div class="row_texttitle">レース場</div>
            <div class="content_item">
              <select
                class="form-select"
                v-model="youtubeedit.boatracePlace"
                @change="setNullIfEmpty('boatracePlace')"
                name="boatrace_course"
              >
                <option value=""></option>
                <option
                  v-for="place in places"
                  :value="place.value"
                  :key="place.text"
                >
                  {{ place.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="item_parent">
            <div class="row_texttitle">レース番号</div>

            <div class="content_item">
              <select
                class="form-select"
                v-model="youtubeedit.raceNo"
                @change="setNullIfZero('raceNo')"
                name="race_no"
              >
                <option value="0"></option>
                <option
                  v-for="raceNo in raceNos"
                  :value="raceNo.value"
                  :key="raceNo.text"
                >
                  {{ raceNo.text }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <p class="error-message" v-if="raceErrorMessage">
          {{ raceErrorMessage }}
        </p>
      </div>
    </div>

    <div class="title content_line d-flex frex-row">
      <div class="item_parent">
        <div class="content_title">
          <div class="texttitle">公開日時</div>
        </div>
        <div class="content_item flex-column">
          <div class="d-flex flex-row mt-2">
            <VueCtkDateTimePicker
              class="input_content input_content_date vue_date_time"
              :button-clear="false"
              button-now-translation="現在時刻"
              v-model="youtubeedit.fromDate"
              format="YYYY-MM-DDTHH:mm"
              formatted="YYYY年MM月DD日 HH:mm"
              :no-header="true"
              label="日付を選択"
              no-label
              no-clear-button
              auto-close
            />
            <span class="span-nami">～</span>
            <VueCtkDateTimePicker
              button-now-translation="現在時刻"
              class="input_content input_content_date vue_date_time"
              :button-clear="false"
              v-model="youtubeedit.toDate"
              format="YYYY-MM-DDTHH:mm"
              formatted="YYYY年MM月DD日 HH:mm"
              :no-header="true"
              label="日付を選択"
              no-label
              no-clear-button
              auto-close
            />
          </div>
        </div>
      </div>
    </div>
    <div class="content_line d-flex flex-wrap justify-content-start">
      <div class="item_parent">
        <div class="content_item mx-2">
          <div class="form-check">
            <label for="pr" class="ms-1 font-bold form-check-label">PR</label>
            <input
              class="form-check-input"
              v-model="checkboxPr"
              type="checkbox"
              id="pr"
            />
          </div>
        </div>
      </div>

      <div class="item_parent">
        <div class="row_texttitle">NEWアイコン表示</div>
        <div class="content_item">
          <select class="form-select" v-model="youtubeedit.newIcon" name="new">
            <option value=""></option>
            <option
              v-for="newIcon in newIcons"
              :value="newIcon.value"
              :key="newIcon.text"
            >
              {{ newIcon.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="item_parent">
        <div class="content_item mx-2">
          <div class="form-check">
            <label for="immediatelyOpen" class="ms-1 font-bold form-check-label"
              >即時公開</label
            >
            <input
              :disabled="!hasPermission(roleStore.role, 'PUBLISH_INSTANTLY')"
              class="form-check-input"
              v-model="checkboxImmediatelyOpen"
              type="checkbox"
              id="immediatelyOpen"
            />
          </div>
        </div>
      </div>
      <div class="item_parent">
        <div class="row_texttitle">承認</div>
        <div class="content_item">
          <select
            :disabled="!hasPermission(roleStore.role, 'PUBLISH_INSTANTLY')"
            class="form-select"
            v-model="youtubeedit.approval"
          >
            <option value="2">未承認</option>
            <option value="1">承認</option>
            <option value="3">却下</option>
          </select>
        </div>
      </div>
    </div>
    <div class="send_button">
      <button
        :disabled="!hasPermission(roleStore.role, 'ARTICLE_REGIST')"
        class="submit_button send_button"
        v-on:click="send"
      >
        登録
      </button>
      <button
        v-if="id"
        class="send_button submit_button"
        @click="previewYoutube(id)"
      >
        プレビュー
      </button>
    </div>
  </div>
</template>

<script setup>
import axios from "axios";
import { ref, reactive, computed, watch, watchEffect, onMounted } from "vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import imageFunction from "@/components/image.js";
import { useStore } from "@/store/authStore";
import { useCodeStore } from "@/store/codeStore";

import { useRouter, useRoute } from "vue-router";

import useRole from "@/components/role";
import { useRoleStore } from "@/store/roleStore";
import { useApiStore } from "@/store/apiStore";
const apiStore = useApiStore();
const roleStore = useRoleStore();
const { hasPermission } = useRole();
// ストアの使用

const store = useStore();
const codeStore = useCodeStore();

const router = useRouter();
const route = useRoute();

const goBack = () => {
  router.go(-1);
};

const { getImageFromUrl } = imageFunction();
const { uploadFile } = imageFunction();

const tokenHeaders = store.getTokenHeaders;
let apiUrl = apiStore.getYoutubeEditPath; //`http://boatrace-prod-public-alb-958219121.ap-northeast-1.elb.amazonaws.com/api/v1/youtubeedit`;

let id = ref(null);

const initialState = {
  kind: 1,
  title: null,
  category: "04",
  series: "",
  tag: "",
  writer: "",
  pr: 0,
  articleCd: null,
  article: "",
  thumbnail: null,
  raceDate: "",
  boatracePlace: null,
  raceNo: null,
  recordDate: new Date(),
  fromDate: (() => {
    const d = new Date();
    d.setHours(22, 0, 0, 0);
    return d;
  })(),
  toDate: new Date(2099, 11, 31, 23, 59, 0),
  immediatelyOpen: 0,
  newIcon: 0,
  approval: 2,
};

const youtubeedit = reactive({ ...initialState });

// 日付のフォーマット
let formattedFromDate = ref(codeStore.formatDateTime(youtubeedit.fromDate));
let formattedToDate = ref(codeStore.formatDateTime(youtubeedit.toDate));

// チェックボックスのリアクティブ変数
// チェックボックスの値を監視
const checkboxPr = computed({
  get: () => youtubeedit.pr === 1,
  set: (value) => {
    youtubeedit.pr = value ? 1 : 0;
  },
});

const checkboxImmediatelyOpen = computed({
  get: () => youtubeedit.immediatelyOpen === 1,
  set: (value) => {
    youtubeedit.immediatelyOpen = value ? 1 : 0;
    if (value) {
      const now = new Date();
      youtubeedit.fromDate = now;
      youtubeedit.approval = 1; // 承認に設定
    }
  },
});

const setNullIfZero = (prop) => {
  if (youtubeedit[prop] === "0") {
    youtubeedit[prop] = null;
  }
};

const setNullIfEmpty = (prop) => {
  if (youtubeedit[prop] === "") {
    youtubeedit[prop] = null;
  }
};

// 掲載開始・終了日時を監視
watch(
  () => youtubeedit.fromDate,
  (newValue) => {
    formattedFromDate.value = codeStore.formatDateTime(newValue);
  }
);
watch(
  () => youtubeedit.toDate,
  (newValue) => {
    formattedToDate.value = codeStore.formatDateTime(newValue);
  }
);

// コードストアからのプルダウンデータの取得

const categories = codeStore.category.filter((item) => item.text === "動画");
const newIcons = codeStore.newIcon;
const raceNos = codeStore.raceNo;
const places = codeStore.places;

// ユーザーが送信ボタンを押したかどうかをトラッキングするref
const hasSubmitted = ref(false);

const isTitleInvalid = computed(() => hasSubmitted.value && !youtubeedit.title);
const isCattegoryInvalid = computed(
  () => hasSubmitted.value && !youtubeedit.category
);
const isArticleCdInvalid = computed(
  () => hasSubmitted.value && !youtubeedit.articleCd
);

const image = ref(null);
const fileInput = ref(null);

const isFileDeleted = ref(false);
watchEffect(async () => {
  if (isFileDeleted.value) return;
  if (youtubeedit.thumbnail) {
    image.value = await getImageFromUrl(youtubeedit.thumbnail);
  }
  youtubeedit.thumbnail = image.value;
});

/**
 * 実際のファイル入力フィールドをトリガーする
 */
const triggerFileInput = () => {
  isFileDeleted.value = true; // fileDeleteが実行されたことをマーク
  // refを使用して非表示のファイル入力フィールドをトリガー
  fileInput.value.click();
};

const fileName = ref(null);
const handleFileChange = async (event) => {
  try {
    fileName.value = event.target.files[0].name;
    await uploadFile(event, image);
    youtubeedit.thumbnail = image.value;
  } catch (e) {
    return;
  }
};

const fileDelete = () => {
  isFileDeleted.value = true; // fileDeleteが実行されたことをマーク
  fileName.value = null;
  image.value = null;
  youtubeedit.thumbnail = null;
};

const raceErrorMessage = ref();

// 許可されたパターンをデータとして定義
const allowedPatterns = [
  { raceDate: false, boatracePlace: false, raceNo: false },
  { raceDate: true, boatracePlace: false, raceNo: false },
  { raceDate: true, boatracePlace: true, raceNo: false },
  { raceDate: true, boatracePlace: true, raceNo: true },
];

/**
 * レース情報の入力チェック関数。
 * 入力されたレース情報が許可されたパターンに合致するかを検証し、
 * 不一致の場合は適切なエラーメッセージを設定する。
 */
const validate = () => {
  // youtubeeditが未定義の場合、関数を終了
  if (!youtubeedit) {
    return;
  }

  // エラーメッセージの初期化
  raceErrorMessage.value = "";

  // 入力値のパターンを定義
  const inputPattern = {
    raceDate: !!youtubeedit.raceDate,
    boatracePlace: !!youtubeedit.boatracePlace,
    raceNo: youtubeedit.raceNo != null && youtubeedit.raceNo !== 0, // nullまたは0の場合はfalse、それ以外はtrue
  };

  // 最小不一致パターンとその不一致数を初期化
  let minimumMismatchPattern = null;
  let minimumMismatchCount = Infinity;

  // 許可されたパターンごとに検証
  allowedPatterns.forEach((pattern) => {
    let mismatchCount = 0;
    let isSubPattern = true;

    // 各キーに対して入力パターンと許可されたパターンを比較
    Object.keys(inputPattern).forEach((key) => {
      if (inputPattern[key] && !pattern[key]) {
        isSubPattern = false;
      }
      if (inputPattern[key] !== pattern[key]) {
        mismatchCount++;
      }
    });

    // サブパターンかつ最小不一致数の場合、パターンを更新
    if (isSubPattern && mismatchCount < minimumMismatchCount) {
      minimumMismatchCount = mismatchCount;
      minimumMismatchPattern = pattern;
    }
  });

  if (minimumMismatchPattern) {
    const errorMessages = [];
    // 最小不一致パターンに対して、各キーの日本語名を取得し、エラーメッセージを生成
    Object.keys(inputPattern).forEach((key) => {
      if (!inputPattern[key] && minimumMismatchPattern[key]) {
        let jpName = "";
        switch (key) {
          case "raceDate":
            jpName = "レース日";
            break;
          case "boatracePlace":
            jpName = "レース場";
            break;
          case "raceNo":
            jpName = "レース番号";
            break;
        }
        errorMessages.push(jpName);
      }
    });

    // エラーメッセージがあれば設定
    if (errorMessages.length > 0) {
      raceErrorMessage.value = `${errorMessages.join(
        "、"
      )}が選択されていません。`;
    }
  } else {
    raceErrorMessage.value = "選択された組み合わせは許可されていません。";
  }
};

// 各項目の変更を監視し、変更があった場合に入力チェックを行う
watchEffect(validate);

let apiUrlId = null;
const getYoutubeData = async (newId) => {
  try {
    // API URLにIDを追加
    apiUrlId = apiUrl + `/${newId}`;
    // axiosでgetリクエストを送信
    const response = await axios.get(apiUrlId, tokenHeaders);

    if (response.status != 200) {
      alert("検索エラー");
    }

    // 取得した記事データをyoutubeeditに更新
    Object.assign(youtubeedit, response.data);
    youtubeedit.immediatelyOpen = isNaN(
      parseInt(response.data.immediatelyOpen, 10)
    )
      ? 0
      : parseInt(response.data.immediatelyOpen, 10);
    youtubeedit.pr = isNaN(parseInt(response.data.pr, 10))
      ? 0
      : parseInt(response.data.pr, 10);
    id.value = newId;
    console.log(youtubeedit.raceNo);
    console.log(response.data.raceNo);
  } catch (error) {
    console.log(error.toJSON());
    alert("検索エラー: " + error.message);
    router.push({ name: "youtubeInput", params: { id: null } });
  }
};

watch(
  () => route.params,
  async (newParams) => {
    //URLのidが0以外なら検索
    if (!newParams.id) {
      id.value = 0;
      Object.assign(youtubeedit, initialState);
      return;
    }
    try {
      // 検索を実行
      getYoutubeData(newParams.id);
    } catch (error) {
      console.error(error);
    }
  },
  { immediate: true, deep: true }
); //即時実行と深い監視

onMounted(async () => {
  if (!route.params.id) {
    id.value = 0;
    Object.assign(youtubeedit, initialState);
  }
});

const previewYoutube = async (id) => {
  try {
    const apiUrlPre = apiStore.getIssuekeyPath; //`http://boatrace-prod-public-alb-958219121.ap-northeast-1.elb.amazonaws.com/api/v1/issuekey`
    const response = await axios.get(apiUrlPre, tokenHeaders);
    if (response.status == 200) {
      const previeUrl = `${process.env.VUE_APP_PREVIEW_SERVER}/article/movie/${id}?key=${response.data.key}`;
      window.open(previeUrl, "_blank");
    }
  } catch (error) {
    alert("キー取得に失敗しました。", error);
  }
};
let isFromToDateInvalid = ref(false);
let errMessage = ref();

const send = async () => {
  hasSubmitted.value = true;
  // 掲載開始と終了の日時のバリデーション
  if (formattedToDate.value <= formattedFromDate.value) {
    isFromToDateInvalid.value = true;
  } else {
    isFromToDateInvalid.value = false;
  }

  let messages = [];

  if (isFromToDateInvalid.value) {
    messages.push("掲載開始時刻と掲載終了時刻が不正です");
  }

  if (isArticleCdInvalid.value) {
    messages.push("YouTubeコードが入力されていません");
  }

  if (isTitleInvalid.value) {
    messages.push("タイトルが入力されていません");
  }

  if (raceErrorMessage.value) {
    messages.push(raceErrorMessage.value);
  }

  errMessage.value = messages.join("\n");

  if (
    isFromToDateInvalid.value ||
    isTitleInvalid.value ||
    isArticleCdInvalid.value ||
    raceErrorMessage.value
  ) {
    alert(errMessage.value);
    return;
  }

  //youtubeeditをディープコピー
  let sendYoutubeedit = JSON.parse(JSON.stringify(youtubeedit));

  sendYoutubeedit.fromDate = formattedFromDate.value;
  sendYoutubeedit.toDate = formattedToDate.value;
  sendYoutubeedit.recordDate = codeStore.formatDateTime(new Date());

  let response = null;
  let putOrPost = 0; //put:1、post:2

  // 既に記事が存在する場合はput, それ以外はpostリクエストを送る
  if (id.value) {
    const apiUrlId = apiUrl + `/${id.value}`;
    response = await axios
      .put(apiUrlId, sendYoutubeedit, tokenHeaders)
      .catch(function (error) {
        console.log(error.toJSON());
      });
    putOrPost += 1;
  } else {
    response = await axios
      .post(apiUrl, sendYoutubeedit, tokenHeaders)
      .catch(function (error) {
        console.log(error.toJSON());
      });
    putOrPost += 2;
  }

  // レスポンスがエラーだった場合はアラートを出す
  if (!response) {
    alert("登録エラー");
    return;
  }

  // レスポンスが成功だった場合、成功メッセージとともに記事IDを表示
  if (response.status === 200) {
    switch (putOrPost) {
      case 1:
        alert(`記事ID:${id.value}を更新しました。`);
        break;
      case 2:
        id.value = response.data.id;
        alert(`新規で記事を登録しました。\n 記事IDは${response.data.id}です`);
        break;
    }
  } else {
    console.error("データの取得に失敗しました");
    alert("登録できませんでした。");
  }
};
</script>

<style scoped>
.body_content {
  height: auto;
  min-height: auto;
}

input[type="text"]:has(+ .err_margin) {
  margin-bottom: 0.1rem;
}

.content_item_youtube {
  width: 100%;
}

.content_item_youtube textarea {
  min-height: 10rem !important;
}

.back-button {
  font-size: 2rem;
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1000;
  /* 他の要素よりも上に表示するためのz-index */
  padding: 10px 20px;
  background-color: #333;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
}

.back-button:hover {
  opacity: 0.5;
}
</style>
